namespace appn.views.appBuilder.index {

    class InitArgs {
        canSave: boolean = false;
        shortDateFormatDefault: string = appn.emptyString;
        shortTimeFormatDefault: string = appn.emptyString;
        languages: Array<string> = new Array<string>();
    }

    let _initArgs: InitArgs;
    const _DataSources: Array<string> = [];
    const _StaticOptions: Array<string> = [];
    const tooltipTemplate = '<span class="toolTip" data-widget="popover" data-trigger="manual" data-html="true" data-content="%hint%" data-container="body" data-placement="top"><i class="fa fa-question-circle"></i></span>';

    export function init(args: InitArgs): void {
        _initArgs = args;

        services.validateDateFormat(String($('#AppConfig_DateFormat').val()), $('#dateFormatResult'));
        services.validateDateFormat(String($('#AppConfig_TimeFormat').val()), $('#timeFormatResult'));
        
        minicolors.init(function (this: any) {
            // Update preview if necessary
            if ($('#colorPreview').length) {
                const picker = String(this.id);

                (picker.containsIgnoreCase('Background')) ? minicolors.refreshPreviewBody() : minicolors.refreshPreviewTitle();
            }
        },
            args.canSave, $('.colorPickerLeftBottom'), 'bottom left');

        minicolors.init(function (this: any) { }, args.canSave, $('.infoAlertFormulaColor'), 'bottom left');

        minicolors.init(function (this: any) {
            // Update preview if necessary
            if ($('#colorPreview').length) {
                const picker = String(this.id);

                (picker.containsIgnoreCase('Background')) ? minicolors.refreshPreviewBody() : minicolors.refreshPreviewTitle();
            }
        },
            args.canSave, $('.colorPickerRightBottom'), 'bottom right');

        minicolors.init(function (this: any) {
            // Update preview if necessary
            if ($('#colorPreview').length) {
                const picker = String(this.id);

                (picker.containsIgnoreCase('Background')) ? minicolors.refreshPreviewBody() : minicolors.refreshPreviewTitle();
            }
        },
            args.canSave, $('.colorPickerLeftTop'), 'top left');

        minicolors.init(function (this: any) {
            // Update preview if necessary
            if ($('#colorPreview').length) {
                const picker = String(this.id);

                (picker.containsIgnoreCase('Background')) ? minicolors.refreshPreviewBody() : minicolors.refreshPreviewTitle();
            }
        },
            args.canSave, $('.colorPickerRightTop'), 'top right');

        $('.bgColourTransparent').each(function () {
            setBackgroundColor($(this));
            $(this).trigger('change');
        });

        // Pre populate the local privates with the DOM values and wipe the corresponding opposing values
        $('.choices .isDataSource').each(function (index: number, isDataSource: HTMLElement) {
            const radiosList = $('.choices .editorRadios input[type = "radio"]');
            const dataSourceList = $('.choices .dataSource');
            const staticOptionsList = $('.choices .staticList');
            if (JSON.parse(String($(isDataSource).val()).toLowerCase())) {
                // Unhide the editor
                $(`.choices#${index}`).find('.dsSelector').removeClass('d-none');

                // Populate the local variable
                _DataSources.push(String($(dataSourceList[index]).val()));

                // Populate the DS list with the correct DS
                $(`.choices#${index}`).find(`.dsSelector select option`).each(function (i, option) {
                    if ($(option).text() === _DataSources[index])
                        $(`.choices#${index}`).find('.dsSelector select').val(String($(option).val()));
                });

                // Set the radio
                (radiosList[(index * 2) + 1] as HTMLInputElement).checked = true;

                // Clear the corresponding DOM value
                if (Number($(staticOptionsList[index]).closest('.choices').attr('id')) === index)
                    $(`.choices#${index} .staticList`).val('');

                _StaticOptions.push(emptyString);
            } else {
                // Unhide the editor
                $(`.choices#${index}`).find('.optionsEditor').removeClass('d-none');

                // Populate the local variable
                // Take apart the original DOM value
                let newOptionsListString = '';
                let newOptionsList: Array<string> = [];
                if (String($(staticOptionsList[index]).val()).contains(','))
                    String($(staticOptionsList[index]).val()).split(',').forEach(function (option, i) {
                        newOptionsList.push(option);
                    });
                else if (String($(staticOptionsList[index]).val()).contains('|'))
                    newOptionsList.push(String($(staticOptionsList[index]).val()));

                // Static Options should never be saved empty so add an empty one on the end
                newOptionsList = newOptionsList.filter(e => e !== '|');
                if (newOptionsList.length === 0)
                    newOptionsList.push('|');

                newOptionsListString = newOptionsList.join(',');

                _StaticOptions.push(newOptionsListString);

                // Populate the Static options List with the correct options +1 empty one
                handleStaticOptions('populate', undefined, undefined, 0, $(`.choices#${index}`).find('.optionsEditor'));

                // Set the radio
                (radiosList[(index * 2)] as HTMLInputElement).checked = true;

                // Clear the corresponding DOM value
                if (Number($(dataSourceList[index]).closest('.choices').attr('id')) === index)
                    $(`.choices#${index} .dataSource`).val('');

                _DataSources.push(emptyString);
            }
        });

        // Pre populate the action buttons styles and background colours for page load
        $('.action .button').each((index: number, button: HTMLElement) => {
            const dataName = $(button).data('name');
            const styleElement = $(button).find('.fontStyle');
            const control = $(`.control.action`);
            const checkbox = $(button).find('.colorSelector input[type="checkbox"]');

            setActionButtonStyle(control, dataName, styleElement);
            setActionButtonBackground(control, dataName, checkbox);
        });

        // Pre populate the media (Primary/Secondary/Tertiary) buttons background colours for page load
        $('.fieldTheme.field .colorSelector[data-name^="btnColor"]').each((index: number, colorSelector: HTMLElement) => {
            const $colorSelector = $(colorSelector);
            const settingName = $colorSelector.data('name') as string; // e.g., "btnColor0"
            const control = $(`.control.inputMedia`);
            const checkbox = $colorSelector.find('input[type="checkbox"]');

            let dataName = ''; // This is the preview button name, e.g., "media-btn0"
            if (settingName === 'btnColor0') dataName = 'media-btn0';
            else if (settingName === 'btnColor1') dataName = 'media-btn1';
            else if (settingName === 'btnColor2') dataName = 'media-btn2';

            if (dataName && control.length && checkbox.length) {
                setActionButtonBackground(control, dataName, checkbox);
            }
        });

        // Pre populate the media (Primary/Secondary/Tertiary) buttons text colours for page load
        $('.fieldTheme.field .tab-pane[data-name^="btn"]').each(function() {
            const $tabPane = $(this);
            const $textColorPicker = $tabPane.find('.backgroundStyle .colorPicker'); // [cite: 262, 280, 297]
            if (!$textColorPicker.length) return; // Not a tab with a text color picker

            const control = $(`.control.inputMedia`);
            let dataName = emptyString;
            const tabName = $tabPane.data('name') as string; // "btn0", "btn1", "btn2" [cite: 255]

            if (tabName === 'btn0') dataName = 'media-btn0';
            else if (tabName === 'btn1') dataName = 'media-btn1';
            else if (tabName === 'btn2') dataName = 'media-btn2';

            if (dataName && control.length) {
                setMediaButtonTextColor(control, dataName, $textColorPicker);
            }
        });

        if (!($('#AppConfig_InfoAlertConfig_TitleStyle_Color').val() as string).startsWith('#'))
            showFormulaButtons($('#AppConfig_InfoAlertConfig_TitleStyle_Color'));

        if (!($('#AppConfig_InfoAlertConfig_SubtitleStyle_Color').val() as string).startsWith('#'))
            showFormulaButtons($('#AppConfig_InfoAlertConfig_SubtitleStyle_Color'));

        if (!($('#AppConfig_InfoAlertConfig_BackgroundColor').val() as string).startsWith('#'))
            showFormulaButtons($('#AppConfig_InfoAlertConfig_BackgroundColor'));

        updateInfoAlertText();
        updateTextStyle($('.controlLabelInfoAlertTitle'), $('.infoAlertTitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
        updateTextStyle($('.controlLabelInfoAlertSubtitle'), $('.infoAlertSubtitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
        updateInfoAlertColors($('#titleColor'));
        updateInfoAlertColors($('#subtitleColor'));
        updateInfoAlertColors($('#bgColor'));

        addEvents();
        showSelectedTheme();

        toggleOptionalSelects();

        select.init({ selector: 'select.themeSelector,.propertiesPane.rightPropertiesPane select:not(.iconSelect)', omitWidth: true });
        select.init({ selector: '.interactionType,.interactScreen,.interactDoc', omitWidth: false });   // Separated to not omitWidth
        select.init({
            selector: '#iconsToDisplay',
            isIconSelect: true
        });
        select.init({
            selector: '.fieldTypeIconPicker',
            isIconSelect: true
        });
    }

    function addEvents(): void {
        $('#AppConfig_DateFormat').change(function () {
            if (!(String($('#AppConfig_DateFormat').val()).length > 0))
                $('#AppConfig_DateFormat').val(_initArgs.shortDateFormatDefault);

            appn.services.validateDateFormat(String($('#AppConfig_DateFormat').val()), $('#dateFormatResult'));
        });

        $('#AppConfig_TimeFormat').change(function () {
            if (!(String($('#AppConfig_TimeFormat').val()).length > 0))
                $('#AppConfig_TimeFormat').val(_initArgs.shortTimeFormatDefault);

            appn.services.validateDateFormat(String($('#AppConfig_TimeFormat').val()), $('#timeFormatResult'));
        });

        $('#AppConfig_StartScreen').change(function () {
            if ($(this).val() === '00000000-0000-0000-0000-000000000000') 
                $('.customiseStart').show();
            else 
                $('.customiseStart').hide();
        });

        $('.function-icon').on('click', function () {
            showFormulaButtons($(this));
            const parentDiv = $(this).closest('div.propContent');
            parentDiv.find('.colorVal').val(parentDiv.find('.formula input').val() as string);
        });

        $('.color-function-icon').on('click', function () {
            hideFormulaButtons($(this));
            const parentDiv = $(this).closest('div.propContent');
            parentDiv.find('.colorVal').val(parentDiv.find('.color-picker input').val() as string);
        });

        $('.toggleDesignerLanguages').click((event) => {
            event.preventDefault();
            $('#designerLanguagesModal').modal('show');
        });

        $(document).on('click', '.buildIcon,.formula-icon', function (this: HTMLElement, e: Event) {
            e.preventDefault();

            const formulaBox = $(this).closest('div.input-group-sm').find('input');
            appn.ui.formulabuilder.currentFormula = formulaBox.val() as string;
            appn.ui.formulabuilder.currentMode = $(this).data('type');
            appn.ui.formulabuilder.formulaUpdated = function (formula: string) {
                formulaBox.val(formula);
                formulaBox.trigger('change');
                formulaBox.trigger('keyup');
            };
            appn.ui.formulabuilder.showDialog();
        });

        $('.btn-applyLanguageChange').on('click', (event) => {
            event.preventDefault();
            $('#designerLanguagesModal').modal('hide');

            const selectedLanguage = $('#SelectedInfoAlertLanguage').val() as string;
            _initArgs.languages.forEach((language, i, a) => {
                const titleInput = $(`input[name="AppConfig.InfoAlertConfig.Title[${language}]"`).closest('.titleInput');
                const subtitleInput = $(`input[name="AppConfig.InfoAlertConfig.Subtitle[${language}]"`).closest('.subtitleInput');

                titleInput.toggleClass("d-none", language !== selectedLanguage);
                subtitleInput.toggleClass("d-none", language !== selectedLanguage);
            });

            $('#displaySelectedLanguage').text(selectedLanguage == 'eng' ? 'english' : selectedLanguage);
            updateInfoAlertText();
        });

        $(document).on('keyup', '.titleInput input,.subtitleInput input', function () {
            updateInfoAlertText();
        });

        $('#iconsToDisplay').change(function () {
            $('#infoAlertConfigIcon').attr('src', $('#iconsToDisplay').find(':selected').data('imagesrc'));
        });

        $('#AppConfig_TitleTextColor').change(function () {
            $('.titleBar .controlLabel').css('color', $('#AppConfig_TitleTextColor').val() as string);
        });

        $(document).on('change', '.interactionSelect,.interactValue,.interactScreen,.interactDoc', function (e: Event) {
            e.preventDefault();

            // Update Global prop collection
            toggleOptionalSelects();
        });

        $(document).on('change', '#titleColor,#titleColorFormula,#subtitleColor,#subtitleColorFormula,#bgColor,#bgColorFormula', function () {
            $(this).closest('div.propContent').find('.colorVal').val($(this).val() as string);
            updateInfoAlertColors($(this));
        });

        $('#AppConfig_NavStyle_Color').change(function () {
            $('.titleBar .controlInfo  span').css('color', $('#AppConfig_NavStyle_Color').val() as string);
        });

        $('#AppConfig_TitleTextColor').trigger('change');
        $('#AppConfig_NavStyle_Color').trigger('change');
        $('#AppConfig_StartScreen').trigger('change');

        $('.fontStyle .displayButton').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).closest('.fontStyle').find('.decor').val('Normal');
            } else {
                $(this).closest('.fontStyle').find('.active').removeClass('active');
                $(this).addClass('active');
                $(this).closest('.fontStyle').find('.decor').val($(this).data('type'));
            }
            updateThemeDisplay();
            updateTextStyle($('.controlLabelInfoAlertTitle'), $('.infoAlertTitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
            updateTextStyle($('.controlLabelInfoAlertSubtitle'), $('.infoAlertSubtitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
        });

        $('#AppConfig_InfoAlertConfig_TitleStyle_Size,#AppConfig_InfoAlertConfig_SubtitleStyle_Size').change(function () {
            updateTextStyle($('.controlLabelInfoAlertTitle'), $('.infoAlertTitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
            updateTextStyle($('.controlLabelInfoAlertSubtitle'), $('.infoAlertSubtitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
        });

        $('.themeSelector').change(function () {
            showSelectedTheme();
            $('.rightPropsScroller').scrollTop($('.rightPropsScroller')[0].scrollHeight);
        });

        // Rejig this for tracking default theme and unchecking other flags
        $('.btnDefaultTheme').click(function () {
            customSubmit('DefaultTheme');
        });

        $('.btnAddTheme').click(function () {
            customSubmit('AddTheme');
        });

        $('.btnDeleteTheme').click(function () {
            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: T('Delete Theme'),
                message: T('Are you sure you want to delete?'),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function (result: boolean) {
                    if (result)
                        customSubmit('DeleteTheme');
                }
            });
        });

        $('.typeSelect .dropdown-menu a').on('click', function (this: HTMLElement, e: Event) {
            setTypeSelect($(this).data('typevalue') as string, $(this).text());
            showSelectedTheme();
        });

        $('.typeSelect').on('change', function (e: Event) {
            showSelectedTheme();
        });

        $('.designerTheme').find('input, select').change(function () {
            updateThemeDisplay();
        });

        $('.control').click(function (e) {
            if ($(this).hasClass('titleBar') || $(this).hasClass('infoAlertPreview'))
                return;
            
            e.stopPropagation();
            
            const typeVal = $(this).data('type');
            setTypeSelect(typeVal);
            $('.typeSelect .dropdown-toggle').trigger('change');
        });

        $('.colorPicker').change(function () {
            if ($(this).val())
                $(this).closest('.backgroundStyle').find('.bgColourTransparent').prop('checked', false);
        });

        $('.titleBar, .workspaceContainer').click(function () {
            $('.rightPropsScroller').scrollTop(0);
        });

        $('input[id$="IsDefault"]').on('click', function (this: HTMLElement, e: Event) {
            const themeGuid = $(this).closest('.themeName').find('input.id').val();

            // Shift isDefault to current checkbox
            $('input[id$="IsDefault"]').prop('checked', false);
            $(this).prop('checked', true);

            // Remove "(Default)" from the previous theme
            $('.themeSelector').find('option').each((i: number, o: HTMLElement) => {
                if ($(o).text().toLowerCase().indexOf('(default)'))
                    $(o).text($(o).text().replace(' (Default)', ''));
            });

            // Add "(Default)" to the current theme
            $('.themeSelector').find(`option[value="${themeGuid}"]`).text($('.themeSelector').find(`option[value="${themeGuid}"]`).text() + ' (Default)');
        });

        $('form').on('submit', function() {
            // Specifically target ONLY Primary, Secondary, and Tertiary Media button checkboxes
            const $mediaTransparentCheckboxes = $(this).find('input[id*="-primary-bgtransparent"], input[id*="-secondary-bgtransparent"], input[id*="-tertiary-bgtransparent"]');

            $mediaTransparentCheckboxes.filter(':checked').each(function() {
                const $checkbox = $(this);
                const $parent = $checkbox.closest('.colorSelector');
                const $colorPicker = $parent.find('.colorPicker');

                if ($colorPicker.val() === '') {
                    $colorPicker.val('transparent');
                }
            });
        });

        addChoicesEvents();
        addActionEvents();
        addFieldIconEvents();
    }

    const toggleOptionalSelects = function () {
        const screenContainer = $('.interactScreenContainer');
        const docContainer = $('.interactDocContainer');
        const valueContainer = $('.interactValueContainer');
        const interactionType = $('.interactionSelect').val() as string;

        screenContainer.hideElement();
        docContainer.hideElement();
        valueContainer.showElement();

        if (interactionType == 'OpenScreen') {
            screenContainer.showElement();
            $('#AppConfig_InfoAlertConfig_Interaction_InteractScreen').val($('.interactScreen').val() as string);
        }
        else if (interactionType == 'OpenDoc') {
            docContainer.showElement();
            if ($('.interactDoc').val()) {
                $('#AppConfig_InfoAlertConfig_Interaction_InteractValue').val(appn.emptyString);
                valueContainer.hideElement();
                $('#AppConfig_InfoAlertConfig_Interaction_InteractScreen').val($('.interactDoc').val() as string);
            }
            else {
                valueContainer.showElement();
                $('#AppConfig_InfoAlertConfig_Interaction_InteractScreen').val(appn.emptyString);
            }
        }
        else if (interactionType == 'None') {
            valueContainer.hideElement();
        }

        // set parameters tooltip dynamically as html
        const dynaTipTarget = $('.interactValueContainer .dynatip');
        const toolTip = $(`.interactionTip${interactionType}`).text();
        if (dynaTipTarget.length > 0)
            if (dynaTipTarget.text().length === 0)
                dynaTipTarget.remove();
            else
                dynaTipTarget.text(dynaTipTarget.text()).append(tooltipTemplate.replace('%hint%', toolTip));

        const dynaTip = dynaTipTarget.find('span.toolTip');
        dynaTip.attr('data-content', $('.interactionTip' + interactionType).html());
        popover.init();
    };

    function addChoicesEvents() {
        $('.choices .editorRadios input[type="radio"]').on('click', function (event) {
            const current = (this as HTMLInputElement);
            const parent = $(this).parent();
            const theme = $(this).closest('.choices');
            const themeIndex = Number(theme.attr('id'));
            const choices = parent.find('input[type="radio"]');
            const staticList = $(theme).find('.optionsEditor');
            const dataSource = $(theme).find('.dsSelector');

            choices.each(function (index: number, choice: HTMLElement) {
                (choice as HTMLInputElement).checked = false;
            });

            current.checked = true;

            staticList.addClass('d-none');
            dataSource.addClass('d-none');

            if (String(current.value).containsIgnoreCase('Static')) {
                theme.find('.isDataSource').prop('value', false);
                staticList.removeClass('d-none');

                const staticListString = _StaticOptions[themeIndex];
                let staticListStrings: Array<string> = [];

                if (staticListString.contains(','))
                    staticListStrings = staticListString.split(',');
                else if (staticListString.contains('|'))
                    staticListStrings.push(staticListString);

                if (staticList.find('.optionsList > li').length === 0 && staticListStrings.length === 0)
                    addChoicesStaticRow(staticList, true);
            } else {
                theme.find('.isDataSource').prop('value', true);
                dataSource.removeClass('d-none');
                theme.find('.dsSelect').val(_DataSources[themeIndex]);
            }
        });

        $('.choices .optionsEditor .addOption').on('click', function (event) {
            const parent = $(this).parent();

            addChoicesStaticRow(parent, true);
        });

        $('.choices .dsSelector').on('change', function (event) {
            const selected = String($(this).find('.dsSelect').val());
            const dsName = String($(this).find(`option[value="${selected}"]`).text());
            $(this).closest('.choices').find('.dataSource').val(dsName);
        });

        appn.minicolors.toggleColorPickerMulti();
    }

    function addActionEvents() {
        // Display correct Tab
        $('.action .nav-link').on('click', function () {
            const tabId = parseInt($(this).text().trim()) - 1;
            const tabContents = $('.action .tab-content');

            tabContents.find('.active.show').removeClass('active show'); // Unselect active tab
            tabContents.find(`#tab-${tabId}`).addClass('active show'); // Select the correct tab

            // ensure correct selected nav item, even when changing theme
            $('.action .nav-link').removeClass('active');
            $(`.action #tab-${tabId}-tab`).addClass('active');
        });

        // Style
        $('.action .button[data-name^="btn"]').find('.displayButton').on('click', function () {
            const dataName = $(this).closest('.button').data('name');
            const styleElement = $(this).closest('.fontStyle');
            const controlClass = $(this).closest('.fieldTheme').attr('class')?.split(' ')[1];
            const control = $(`.control.${controlClass}`);

            setActionButtonStyle(control, dataName, styleElement);
        });
        $('.action .button[data-name^="btn"]').find('.colorPicker[id*="BtnStyle"],select[id*="BtnStyle"]').on('change', function () {
            const dataName = $(this).closest('.button').data('name');
            const styleElement = $(this).closest('.fontStyle');
            const control = $(`.control.action`);

            setActionButtonStyle(control, dataName, styleElement);
        });

        // Background
        $('.action .button[data-name^="btn"]').find('.colorPicker,input[type="checkbox"]').on('change', function () {
            const dataName = $(this).closest('.button').data('name');
            const controlClass = $(this).closest('.fieldTheme').attr('class')?.split(' ')[1];
            const control = $(`.control.${controlClass}`);
            const checkbox = $(this).attr('type') === 'checkbox' ? $(this) : $(this).closest('.colorSelector').find('input[type="checkbox"]');

            setActionButtonBackground(control, dataName, checkbox);
        });

        // Primary/Secondary/Tertiary Button Backgrounds
        $('.fieldTheme.field .colorSelector .colorPicker, .fieldTheme.field .colorSelector input[type="checkbox"]').on('change', function () {
            const fieldTheme = $(this).closest('.fieldTheme.field');
            const designerTheme = fieldTheme.closest('.designerTheme');

            if (designerTheme.find('.id').val() !== $('.themeSelector').val()) return;

            const buttonWrapper = $(this).closest('[data-name^="btnColor"]');
            let dataName = emptyString;

            if (buttonWrapper.data('name') === 'btnColor0') dataName = 'media-btn0';
            else if (buttonWrapper.data('name') === 'btnColor1') dataName = 'media-btn1';
            else if (buttonWrapper.data('name') === 'btnColor2') dataName = 'media-btn2';

            if (dataName !== emptyString) {
                const control = $('.control.inputMedia');
                const checkbox = $(this).attr('type') === 'checkbox' ? $(this) : buttonWrapper.find('input[type="checkbox"]');
                setActionButtonBackground(control, dataName, checkbox);
            }
        });

        // Primary/Secondary/Tertiary Button Text Colors
        $('.fieldTheme.field .tab-pane .backgroundStyle .colorPicker').on('change', function () {
            const fieldTheme = $(this).closest('.fieldTheme.field');
            const designerTheme = fieldTheme.closest('.designerTheme');

            if (designerTheme.find('.id').val() !== $('.themeSelector').val()) return;

            const tabPane = $(this).closest('.tab-pane');
            let dataName = emptyString;

            const tabName = tabPane.data('name') as string;
            if (tabName === 'btn0') dataName = 'media-btn0';
            else if (tabName === 'btn1') dataName = 'media-btn1';
            else if (tabName === 'btn2') dataName = 'media-btn2';

            if (dataName !== emptyString) {
                const control = $('.control.inputMedia');
                setMediaButtonTextColor(control, dataName, $(this));
            }
        });
    }

    function addFieldIconEvents() {
        $('.fieldTypeIconManager').each(function () {
            let $manager = $(this);
            let $fieldTypeSelector = $manager.find('.fieldTypeSelector');
            let $iconPicker = $manager.find('.fieldTypeIconPicker');
            let $hiddenFields = $manager.find('.fieldTypeIconMappingsContainer');

            // Event handler for when a user selects a field type
            $fieldTypeSelector.on('change', function () {
                let selectedFieldType = $(this).val();

                if (selectedFieldType) {
                    let iconValue = $hiddenFields.find('input[data-field-type="' + selectedFieldType + '"]').val() as string;
                    $iconPicker.val(iconValue).trigger('change.select2');
                }
            });

            // Event handler for when a user selects an icon
            $iconPicker.on('change', function () {
                let selectedFieldType = $fieldTypeSelector.val();
                if (selectedFieldType) {
                    $hiddenFields.find('input[data-field-type="' + selectedFieldType + '"]').val($(this).val() as string);
                }
            });

            $fieldTypeSelector.trigger('change');
        });
    }
    
    function addChoicesStaticRow(parent: JQuery<HTMLElement>, fromClick: boolean = false) {
        const parser = new DOMParser();
        const index = parent.find('.optionsList > li').length;

        const optionRow = $(parser.parseFromString(`<div class="optionsRow d-flex">
                    <div class="col-sm-6 optionDisplayCol"></div>
                    <div class="col-sm-5 optionValueCol" style="padding-left: 0; padding-right: 0">
                        <input placeholder="${T("Answer Value")}" type="text" class="editorTextfield underlyingValue form-control form-control-sm" />
                    </div>
                    <div class="col-sm-1 optionRemoveCol">
                        <a class="btn btn-danger btn-sm removeOption border-none" href="#removeOption"><i class="fa fa-times"></i></a>
                    </div>
                </div>`, 'text/html').body).find('.optionsRow');

        const displayField = $(parser.parseFromString(`<div class="uiText" name="Option ${(index + 1)}" type="uiText">
                    <ul class="translations list-unstyled">
                        <li class="uiText-translation">
                            <div class="form-inline">
                                <input type="text" class="editorTextfield form-control form-control-sm" style="width:100%;" />
                            </div>
                        </li>
                    </ul>
                </div>`, 'text/html').body).find('.uiText');
        displayField.find('ul input').attr('placeholder', T('Displayed Value'));

        optionRow.find('.optionDisplayCol').append(displayField);

        // Handle answer value column updates
        optionRow.find('.optionValueCol .editorTextfield').val('').on('input', function (event) {
            // Find the index it belongs to
            let index = -1;
            index = Number($($($(this).closest('.optionsRow')).find('.uiText[name^="Option"]')).attr('name')?.split(' ')[1]) - 1;

            // Update that value
            handleStaticOptions('put', 'value', String($(this).val()), index, parent);
        });

        // Handle display value column updates
        optionRow.find('.optionDisplayCol .editorTextfield').val('').on('input', function (event) {
            // Find the index it belongs to
            let index = -1;
            index = Number($($($(this).closest('.optionsRow')).find('.uiText[name^="Option"]')).attr('name')?.split(' ')[1]) - 1;

            // Update that value
            handleStaticOptions('put', 'display', String($(this).val()), index, parent);
        });

        // Handle answer value column updates
        optionRow.find('.removeOption').on('click', function (event) {
            event.preventDefault();
            // find index
            const row = $(this).closest('.optionsRow');
            const option = row.find('.optionDisplayCol > .uiText');
            const index = Number(String(option.attr('name')).split(' ')[1]) - 1;

            // Splice the static row out of the option list
            handleStaticOptions('remove', undefined, undefined, index, parent);

            // Renumber option list
            const $optionsList = $(this).closest('.optionsList');
            $(this).closest('li').remove();
            $optionsList.children().each(function (i) {
                $(this)
                    .toggleClass('even', (i % 2) === 0)
                    .find('.optionDisplayCol .uiText')
                    .attr('name', 'Option ' + (i + 1));
            });
        });

        const newRow = $('<li></li>')
            .toggleClass('even', (index % 2) === 0)
            .append(optionRow);

        parent.find('.optionsList').append(newRow);
        if (fromClick)
            handleStaticOptions('add', undefined, undefined, index, parent);
    }

    function getTypeSelectVal() {
        let $currentTheme = getCurrentDesignerTheme();
        return $currentTheme.find('.typeSelect .dropdown-toggle').data('typevalue');
    }

    function setTypeSelect(val: string, text?: string) {
        let $currentTheme = getCurrentDesignerTheme();
        let $currentToggle = $currentTheme.find('.typeSelect .dropdown-toggle');
        $currentToggle.data('typevalue', val);

        if (text)
            $currentToggle.text(text);
        else {
            const valText = $currentToggle.parent()
                .find(".dropdown-menu")
                .find("[data-typevalue='" + val + "']")
                .first().text();
            $currentToggle.text(valText);
        }
    }

    function showSelectedTheme() {
        if ($('.themeSelector').prop('selectedIndex') > 0)
            $('.btnDeleteTheme').showElement();
        else
            $('.btnDeleteTheme').hideElement();

        const selectedType = getTypeSelectVal();
        $('.designerTheme').hide();
        $('.fieldTheme').hide();
        $('.control').removeClass('selected');
        getCurrentDesignerTheme().find(`.id[value='${$('.themeSelector').val()}']`).closest('.designerTheme').show();
        getCurrentDesignerTheme().find(`.fieldTheme.${selectedType}`).show();
        $(`.control.${selectedType}`).addClass('selected');

        // Initialize default colors for any color pickers in the newly shown theme
        getCurrentDesignerTheme().find('.colorPicker[data-default-color]').each(function() {
            setDefaultColor($(this));
        });

        updateThemeDisplay();
    }

    function customSubmit(submitType: string) {
        $('form').append(`<input type="hidden" name="submitType" value="${submitType}" />`);
        $('form').submit();
    }

    function handleStaticOptions(action: string = emptyString, type: string = emptyString, value: string = emptyString, index: number = -1, parent: JQuery<HTMLElement>) {
        // ViewModel update
        const theme = parent.closest('.choices');
        const themeIndex = Number(theme.attr('id'));
        const staticOptions = theme.find('.staticList');
        const staticListString = _StaticOptions[themeIndex];
        let staticList: Array<string> = [];

        if (staticListString.contains(','))
            staticList = staticListString.split(',');
        else if (staticListString.contains('|'))
            staticList.push(staticListString);

        if (action !== emptyString) {
            switch (action) {
                case 'add': {
                    staticList.push('|');

                    break;
                }
                case 'remove': {
                    staticList.splice(index, 1);

                    break;
                }
                case 'put': {
                    const currentOption = staticList[index];
                    const currentDisplay = currentOption.split('|')[0];
                    const currentValue = currentOption.split('|')[1];

                    switch (type) {
                        case 'display': {
                            staticList.splice(index, 1, `${value}|${currentValue}`);

                            break;
                        }
                        case 'value': {
                            staticList.splice(index, 1, `${currentDisplay}|${value}`);

                            break;
                        }
                    }

                    break;
                }
                case 'populate': {
                    staticList.forEach(function (option, i) {
                        addChoicesStaticRow(parent);

                        const rows = parent.find('.optionsList > li');
                        const row = $(rows[i]);
                        row.find('.optionDisplayCol .editorTextfield').val(option.split('|')[0]);
                        row.find('.optionValueCol .editorTextfield').val(option.split('|')[1]);
                    });

                    break;
                }
            }

            // Update the static options for the page
            _StaticOptions[themeIndex] = staticList.join(',');
            staticOptions.val(staticList.join(','));
        }
    }

    function updateThemeDisplay() {
        getCurrentDesignerTheme().find('.fieldTheme').each(function () {
            const theme = $(this);

            let filter = $(this).find('.fieldType').map(function () {
                return `.${$(this).val()}`;
            }).get().join(',');
            if (!filter)
                filter = '.control';

            $('.workspace').find('.control').filter(filter).each(function () {
                const controlInfo = $(this).find('> .controlInfo');
                updateTextStyle(controlInfo.find('.controlLabel'), theme.find('.labelStyle'), { Small: 1, Medium: 1.2, Large: 1.4 });
                updateTextStyle(controlInfo.find('.controlHint'), theme.find('.hintStyle'), { Small: 0.8, Medium: 0.9, Large: 1.1 });

                const layoutText = theme.find('.layoutStyle select').val() as string;
                if ($(this).hasClass('verticalLayout') || $(this).hasClass('horizontalLayout')) {
                    $(this).removeClass('verticalLayout').removeClass('horizontalLayout');
                    if (layoutText === 'Vertical')
                        $(this).addClass('verticalLayout');
                    else
                        $(this).addClass('horizontalLayout');
                }

                let backgroundElement = controlInfo.find('.controlHeadline');
                backgroundElement.css('background-color', emptyString);
                controlInfo.css('background-color', emptyString);
                if ($(this).hasClass('horizontalLayout'))
                    backgroundElement = controlInfo;

                backgroundElement.css('background-color', theme.find('.backgroundStyle .colorPicker').val() as string);
                
                if (theme.hasClass('field') && $(this).hasClass('inputMedia')) {
                    const themeIndex = theme.closest('.designerTheme').index();

                    // Find Background Checkboxes
                    const primaryCheckbox = theme.find('#ab-primary-bgtransparent-' + themeIndex);
                    const secondaryCheckbox = theme.find('#ab-secondary-bgtransparent-' + themeIndex);
                    const tertiaryCheckbox = theme.find('#ab-tertiary-bgtransparent-' + themeIndex);

                    // Find Text Color Pickers
                    const primaryTextPicker = theme.find('.tab-pane[data-name="btn0"] .backgroundStyle .colorPicker');
                    const secondaryTextPicker = theme.find('.tab-pane[data-name="btn1"] .backgroundStyle .colorPicker');
                    const tertiaryTextPicker = theme.find('.tab-pane[data-name="btn2"] .backgroundStyle .colorPicker');

                    // Apply Backgrounds
                    if (primaryCheckbox.length) setActionButtonBackground($(this), 'media-btn0', primaryCheckbox);
                    if (secondaryCheckbox.length) setActionButtonBackground($(this), 'media-btn1', secondaryCheckbox);
                    if (tertiaryCheckbox.length) setActionButtonBackground($(this), 'media-btn2', tertiaryCheckbox);

                    // Apply Text Colors
                    if (primaryTextPicker.length) setMediaButtonTextColor($(this), 'media-btn0', primaryTextPicker);
                    if (secondaryTextPicker.length) setMediaButtonTextColor($(this), 'media-btn1', secondaryTextPicker);
                    if (tertiaryTextPicker.length) setMediaButtonTextColor($(this), 'media-btn2', tertiaryTextPicker);
                }
                
                if (filter.contains('inputChoices')) {
                    // Hide or show the option colours and option background
                    // Set the display type 
                    const displayStyleText = theme.find('.displayStyle select').val() as string;

                    if ($(this).hasClass('displayDropdown') || $(this).hasClass('displayListOfChoices') || $(this).hasClass('displayAutoComplete')) {
                        $(this).removeClass('displayDropdown').removeClass('displayListOfChoices').removeClass('displayAutoComplete');

                        // Hide the wireListOfChoices
                        const choices = $(this).find('.wireField .wireListOfChoices');

                        choices.each(function (index: number, choice: HTMLElement) {
                            $(choice).hideElement();
                        });

                        if (displayStyleText === 'Drop Down List')
                            $(this).addClass('displayDropdown');
                        else if (displayStyleText === 'List of Choices') {
                            $(this).addClass('displayListOfChoices');
                            if ($(this).hasClass('verticalLayout'))
                                setOptionColors($('.control.choices'), $('.fieldTheme.choices'), true);

                            choices.each(function (index: number, choice: HTMLElement) {
                                if (index < 3)
                                    $(choice).showElement();
                            });
                        } else
                            $(this).addClass('displayAutoComplete');
                    }

                    const optionsSections = theme.find('.optionColors, .option-bg');
                    optionsSections.each(function (index: number, option: HTMLElement) {
                        if (!$(option).hasClass('d-none'))
                            $(option).addClass('d-none');
                    });

                    // Test to see if the conditions are met to have options
                    if ($(this).hasClass('displayListOfChoices') && $(this).hasClass('horizontalLayout')) {
                        optionsSections.removeClass('d-none');
                        setOptionColors($('.control.choices'), theme.find('.multi-color-content.optionColors'));
                    }
                }

                if (filter.contains('inputAction'))
                    theme.find('.button').each((index: number, button: HTMLElement) => {
                        const dataName = $(button).data('name');
                        const styleElement = $(button).find('.fontStyle');
                        const control = $(`.control.action`);
                        const checkbox = $(button).find('.colorSelector input[type="checkbox"]');

                        setActionButtonStyle(control, dataName, styleElement);
                        setActionButtonBackground(control, dataName, checkbox);
                    });
            });
        });
    }

    function updateTextStyle(element: JQuery<HTMLElement>, textStyle: JQuery<HTMLElement>, fontSizes: { [id: string]: number }, noColorUpdate?: boolean) {
        const fontSizeText = textStyle.find('select').val() as string;
        const fontStyleText = textStyle.find('.decor').val() as string;
        const fontColorText = textStyle.find('.colorPicker').val() as string;
        element.css('font-style', emptyString).css('font-weight', emptyString);
        if (noColorUpdate)
            element.css('font-size', `${fontSizes[fontSizeText]}em`).css('font-style', fontStyleText).css('font-weight', fontStyleText);
        else
            element.css('font-size', `${fontSizes[fontSizeText]}em`).css('color', fontColorText).css('font-style', fontStyleText).css('font-weight', fontStyleText);
    }

    function getCurrentDesignerTheme() {
        return $(`.designerTheme .id[value='${$('.themeSelector').val()}']`).closest('.designerTheme');
    }

    function setBackgroundColor(checkbox: JQuery<HTMLElement>) {
        checkbox.on('change', function () {
            const $thisCheckbox = $(this);

            const $parent = $thisCheckbox.closest('.backgroundStyle, .colorSelector');
            const $colorPicker = $parent.find('.colorPicker');

            if ($thisCheckbox.is(':checked')) {
                ($colorPicker.val(emptyString) as any).minicolors('value', '');
            } else if (!$colorPicker.val()) {
                const defaultColor = $colorPicker.data('default-color') as string || '#EEEEEE';
                ($colorPicker.val(defaultColor) as any).minicolors('value', defaultColor);
            }
        });
    }

    function setOptionColors(control: JQuery<HTMLElement>, multiColorSelector: JQuery<HTMLElement>, clear?: boolean) {
        const colorBoxes: Array<string> = [];
        colorBoxes.push(String(multiColorSelector.find('.colorPicker1').val()));
        colorBoxes.push(String(multiColorSelector.find('.colorPicker2').val()));
        colorBoxes.push(String(multiColorSelector.find('.colorPicker3').val()));
        colorBoxes.push(String(multiColorSelector.find('.colorPicker4').val()));
        colorBoxes.push(String(multiColorSelector.find('.colorPicker5').val()));

        const buttons = control.find('.wireListOfChoices');

        $(buttons).each(function (index: number, button: HTMLElement) {
            const buttonElement = $(button);
            buttonElement.css('background-color', emptyString);
            buttonElement.hideElement();

            if (colorBoxes[index] !== emptyString) {
                buttonElement.css('background-color', colorBoxes[index]);
                buttonElement.showElement();

                if (clear) {
                    buttonElement.css('background-color', '');
                    buttonElement.hideElement();
                }
            }
        });
    }

    function setActionButtonStyle(control: JQuery<HTMLElement>, dataName: string, style: JQuery<HTMLElement>) {
        const button = control.find(`.wireButton[data-name="${dataName}"]`);
        updateTextStyle(button, style, { Small: 1, Medium: 1.2, Large: 1.4 });
    }

    function setActionButtonBackground(control: JQuery<HTMLElement>, dataName: string, checkbox: JQuery<HTMLElement>) {
        const colorPicker = checkbox.closest('.colorSelector').find('.colorPicker');

        if (checkbox.is(':checked')) {
            (colorPicker.val(emptyString) as any).minicolors('value', '');
        } else if (!colorPicker.val()) {
            const defaultColor = colorPicker.data('default-color') as string || '#DDDDDD';
            (colorPicker.val(defaultColor) as any).minicolors('value', defaultColor);
        }

        const button = control.find(`.wireButton[data-name="${dataName}"]`);
        button.css('background', colorPicker.val() as string);
    }

    function setMediaButtonTextColor(control: JQuery<HTMLElement>, dataName: string, colorInput: JQuery<HTMLElement>) {
        const button = control.find(`.wireButton[data-name="${dataName}"]`);
        button.css('color', colorInput.val() as string);
    }

    function setDefaultColor(colorInput: JQuery<HTMLElement>) {
        const currentValue = colorInput.val() as string;
        const defaultColor = colorInput.data('default-color') as string;

        // Check if the input's value is empty or blank
        if (!currentValue || currentValue.trim() === '') {
            colorInput.val(defaultColor);
            (colorInput as any).minicolors('value', defaultColor);
        }
    }

    $(function () {
        // Set default colors when color picker value changes (including when cleared)
        $(document).on('change', 'input.colorPicker[data-default-color]', function() {
            const $this = $(this);
            setTimeout(() => {
                const currentValue = $this.val() as string;
                if (!currentValue || currentValue.trim() === '') {
                    const defaultColor = $this.data('default-color') as string;
                    $this.val(defaultColor);
                    ($this as any).minicolors('value', defaultColor);
                }
            }, 50);
        });
    });

    function showFormulaButtons(control: JQuery<HTMLElement>) {
        control.closest('div.propContent').find('div.formula').showElement();
        control.closest('div.propContent').find('.color-picker').hideElement()
    }

    function hideFormulaButtons(control: JQuery<HTMLElement>) {
        control.closest('div.propContent').find('div.color-picker').showElement();
        control.closest('div.propContent').find('.formula').hideElement()
    }

    function updateInfoAlertColors(control: JQuery<HTMLElement>) {
        const value = control.val() as string;
        const id = control.attr('id') as string;
        if (id.contains('subtitle'))
            $('.controlLabelInfoAlertSubtitle').css('color', value.startsWith('#') ? value : '#f24444');
        else if (id.contains('title'))
            $('.controlLabelInfoAlertTitle').css('color', value.startsWith('#') ? value : '#3F3F3F');
        else if (id.contains('bgColor'))
            $('#infoAlertPreview').css('backgroundColor', value.startsWith('#') ? value : '#FFFFFF');
    }

    function updateInfoAlertText() {
        const titleText = $('.titleInput:not(.d-none) input').val() as string;
        const subtitleText = $('.subtitleInput:not(.d-none) input').val() as string;
        $('.controlLabelInfoAlertTitle').text(utils.hasValue(titleText) ? titleText : T('You have 2 Tasks Outstanding'));
        $('.controlLabelInfoAlertSubtitle').text(utils.hasValue(subtitleText) ? subtitleText : T('1 Overdue!'));
    }

    function formatIcon(icon) {
        if (!icon.id) { return icon.text; }

        // This uses Flexbox to vertically align the icon and text.
        // 'display: flex' turns the span into a flex container.
        // 'align-items: center' vertically centers the items within it.
        let $icon = $(
            '<span style="display: flex; align-items: center;">' +
            '<img src="' + $(icon.element).data('imagesrc') + '" style="height: 1.2em; margin-right: 4px;" />' +
            '<span>' + icon.text + '</span>' +
            '</span>'
        );
        return $icon;
    }
}
